import { MdVisibility, MdVisibilityOff } from 'react-icons/md';
import styled from 'styled-components';

const EyeIconOpen = styled(MdVisibilityOff)`
  cursor: pointer;
`;

const EyeIconClose = styled(MdVisibility)`
  cursor: pointer;
`;

const NoLabel = styled.div``;

const Label = styled.label`
  color: ${(props) =>
    props.$errorMessage
      ? props.theme.COLOR_ERROR_TEXT
      : props.theme.COLOR_GREY_TEXT};
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: 0.4px;
  margin-top: 12px;
  text-align: left;
`;

const InputWrapper = styled.div`
  background-color: ${(props) =>
    props.disabled ? props.theme.COLOR_BG_DARK : props.theme.COLOR_WHITE};
  display: flex;
  outline: 1px solid
    ${(props) =>
      props.$errorMessage
        ? props.theme.COLOR_ERROR_TEXT
        : props.theme.COLOR_GREY5};
  border-radius: 4px;
  border: none;
  height: 48px;
  margin-top: 4px;
  align-items: center;
  width: 100%;

  &:focus-within {
    outline: 1px solid ${(props) => props.theme.COLOR_BLACK};
  }
  /* this removes the up and down arrows from the input field if type is 'number' */
  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none !important;
    margin: 0 !important;
  }
  /* Firefox */
  input[type='number'] {
    -moz-appearance: textfield;
  }
`;

const IconContainer = styled.div`
  margin-right: 7px;
  margin-left: 11px;
  display: flex;
`;

const EttxInput = styled.input`
  width: 100%;
  height: 100%;
  border: none;
  outline: none;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: 0.2px;
  text-align: left;
  padding-left: ${({ $iconLeft }) => ($iconLeft ? '0' : '12px')};
  padding-right: ${({ $iconRight }) => ($iconRight ? '0' : '12px')};
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'text')};
  background-color: ${({ $shouldInheritBackgroundColor }) =>
    $shouldInheritBackgroundColor ? 'inherit' : 'initial'};
  color: ${({ $shouldInheritBackgroundColor }) =>
    $shouldInheritBackgroundColor ? 'inherit' : '#000000'};
  &::placeholder {
    color: ${(props) =>
      props.$errorMessage
        ? props.theme.COLOR_ERROR_TEXT
        : props.theme.COLOR_GREY4};
    font-weight: 400;
  }

  &:focus {
    &::placeholder {
      color: ${(props) => props.theme.COLOR_GREY4};
      font-weight: 400;
    }
  }
`;

const EttxTextArea = styled.textarea`
  width: 100%;
  min-height: 100px;
  min-width: 100%;
  max-width: max-content;
  height: 100%;
  font-size: 16px;
  color: #000000;
  outline: 0;
  padding-top: 12px;
  border: 1px solid ${({ theme }) => theme.COLOR_GREY5};
  padding-left: ${({ $iconLeft }) => ($iconLeft ? '0' : '12px')};
  padding-right: ${({ $iconRight }) => ($iconRight ? '0' : '12px')};
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'text')};
  white-space: pre-wrap; // This ensures that new lines are respected
  &::placeholder {
    color: ${({ placeholdercolor }) => placeholdercolor};
    font-weight: 400;
  }
`;

const Container = styled.div`
  /* margin: 0 0 12px 0; */
  width: 100%;
`;

const StyledInput = {
  Label,
  EttxInput,
  EttxTextArea,
  IconContainer,
  InputWrapper,
  NoLabel,
  EyeIconClose,
  EyeIconOpen,
  Container,
};

export default StyledInput;
